/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useState, useEffect } from 'react';
import {
    CpdsCheckboxContainer,
    CpdsCheckbox,
    CpdsCheckboxLabel,
    CpdsHelperLabel,
    CpdsHelperTextWrapper,
    CpdsCheckboxWrapper
} from '../styles/cpds-input-fields-style';
import { CpdsCheckboxProps } from '../typings';
import { Cpds } from '@Cpds.Ui';

const Checkbox: React.FC<CpdsCheckboxProps> = ({
    inputId = "",
    domRef = null,
    exClasses = '',
    styleOverrides = {},
    Label = '',
    Checked = false,
    onChange = () => { },
    getValue = () => { },
    isError = false,
    ErrorMessage = '',
    ErrorIcon = 'information',
    ErrorIconSize = { width: '20', height: '20' },
    isOverRideTypography = false
}) => {
    const [isChecked, setIsChecked] = useState(Checked);
    const [chkEvent, setChkEvent] = useState(null);
    useEffect(() => {
        if (onChange) {
            onChange(chkEvent);
        }
        if (getValue) {
            getValue(chkEvent);
        }
    }, [chkEvent, onChange, getValue]);

    const handleCheckboxChange = useCallback((event) => {
        setIsChecked(prevIsChecked => !prevIsChecked);
        setChkEvent(event);
        if (getValue) {
            getValue(event);
        }
    }, [getValue]);

    return (
        <CpdsCheckboxContainer
            className={`cpds-input-checkbox ${exClasses} ${isError ? 'invalid' : ''}`}
            ref={domRef}
            style={styleOverrides}
        >
            <CpdsCheckboxWrapper>
                <CpdsCheckbox 
                    id={inputId} 
                    checked={isChecked} 
                    onClick={handleCheckboxChange}
                    isError={isError} 
                />
                {Label && <CpdsCheckboxLabel htmlFor={inputId}>{Label}</CpdsCheckboxLabel>}
            </CpdsCheckboxWrapper>

            {isError && ErrorIcon && ErrorMessage && (
                <CpdsHelperTextWrapper>
                    {ErrorIcon && <Cpds.Icon id="ico-3" color={'#C01E1E'} name={ErrorIcon} customSize={ErrorIconSize} />}
                    <CpdsHelperLabel isError={isError} isDisabled={false} isOverRideTypography={isOverRideTypography}>
                        {ErrorMessage}
                    </CpdsHelperLabel>
                </CpdsHelperTextWrapper>
            )}
        </CpdsCheckboxContainer>
    );
};

export default Checkbox;
